module.exports = __webpack_public_path__ + "img/Foam_slicing_stock.51fc01ab.svg";